/* eslint-disable sonarjs/no-duplicate-string */
import React from 'react';
import Lottie, { AnimationItem } from 'lottie-web';
import { Box, Spacer } from '@bcp-nextgen-dx-component-factory/accolade-design-system';
import { useDidMount } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';
import { animations } from '@assets';
import { CardPlanHeader } from '@components';
import { rem } from '@helpers';
import { Anything, PlanDetail } from '@types';
import { useLogger } from '@hooks';
import { usePromotionalCodeDuration } from '@store';

export interface CardPlansHeaderProps {
	plan: PlanDetail;
	opacity: string;
	hasIntegratedSolution: boolean;
	useCode: boolean | undefined;
}

export const CardHeader: React.FC<CardPlansHeaderProps> = ({ plan, opacity, hasIntegratedSolution, useCode }) => {
	const logger = useLogger();
	const promotionalCodeDuration = usePromotionalCodeDuration(plan);
	const animationCostsRef = React.useRef<Anything>(null);
	const animationTaxRef = React.useRef<Anything>(null);
	const lottieCosts = React.useRef<AnimationItem>();
	const lottieTax = React.useRef<AnimationItem>();

	let animationDataCosts: Anything = '';

	const setAnimation = () => {
		if (plan.name.toLowerCase() === 'standard') {
			// deprecated
			// if (hasIntegratedSolution) {
			// 	animationDataCosts = animations.starterPlanIntegratedSolutionAppliedPromotionalCode;
			// } else {
			animationDataCosts = animations.standardPlan;
			// }
		} else if (plan.name.toLowerCase() === 'premium') {
			// deprecated
			// if (hasIntegratedSolution) {
			// 	animationDataCosts = animations.totalPlanIntegratedSolutionAppliedPromotionalCode;
			// } else {
			animationDataCosts = animations.premiumPlan;
			// }
		}

		let appliedPromotionalCodeData;

		switch (promotionalCodeDuration) {
			case 3:
				appliedPromotionalCodeData = animations.promo3Months;
				break;
			case 6:
				appliedPromotionalCodeData = animations.promo6Months;
				break;
			case 9:
				appliedPromotionalCodeData = animations.promo9Months;
				break;
			case 12:
				appliedPromotionalCodeData = animations.promo12Months;
				break;
			case 18:
				appliedPromotionalCodeData = animations.promo18Months;
				break;
			case 24:
				appliedPromotionalCodeData = animations.promo24Months;
				break;
			case 36:
				appliedPromotionalCodeData = animations.promo36Months;
				break;
			default:
				appliedPromotionalCodeData = animations.promo3Months;
		}

		lottieTax.current = Lottie.loadAnimation({
			container: animationTaxRef.current,
			renderer: 'svg',
			loop: false,
			autoplay: false,
			rendererSettings: {
				preserveAspectRatio: 'xMidYMid slice',
			},
			animationData: appliedPromotionalCodeData,
		});

		lottieTax.current?.goToAndStop(1);

		lottieCosts.current = Lottie.loadAnimation({
			container: animationCostsRef.current,
			renderer: 'svg',
			loop: false,
			autoplay: false,
			rendererSettings: {
				preserveAspectRatio: 'xMidYMid slice',
			},
			animationData: animationDataCosts,
		});
		lottieCosts.current?.goToAndStop(1);
	};

	useDidMount(() => {
		setAnimation();
	});

	React.useEffect(() => {
		if (useCode) {
			// if (
			// 	retrievePromoCodeInformation &&
			// 	retrievePromoCodeInformation.code &&
			// 	retrievePromoCodeInformation.code.indexOf('CON') >= 0
			// ) {
			// 	lottieCosts.current?.destroy();
			// 	lottieTax.current?.destroy();
			// 	setAnimationWithChristmasPromo();
			// 	lottieCosts.current?.play();
			// 	lottieTax.current?.play();
			// } else

			lottieCosts.current?.destroy();
			lottieTax.current?.destroy();
			setAnimation();
			lottieCosts.current?.play();
			lottieTax.current?.play();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [useCode]);

	logger('Enter in Card Plan header', {
		plan,
		opacity,
		hasIntegratedSolution,
		useCode,
	});

	return (
		<CardPlanHeader
			name={plan.name}
			opacity={opacity}
			planNote={plan.name.toLowerCase() === 'standard' ? plan.tag : undefined}
		>
			<Box
				styles={{
					flexDirection: 'column',
					width: '100%',
					alignItems: 'stretch',
					margin: rem(60, 0, 0, 0),
				}}
			>
				{/*ANIMATION*/}
				<Box
					styles={{
						display: 'flex',
						// flexDirection: 'column',
						alignItems: 'center',
						justifyContent: 'center',
						margin: rem(48, 16, 0, 24),
					}}
				>
					<div ref={animationCostsRef} />
				</Box>
				<Box
					styles={{
						display: 'flex',
						// flexDirection: 'column',
						alignItems: 'center',
						justifyContent: 'center',
						marginRight: rem(-48),
					}}
				>
					<div ref={animationTaxRef} />
				</Box>
			</Box>
		</CardPlanHeader>
	);
};
